import React from "react";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";

const TableValues = ({label, value, valueTrans}) => (
    <tr>
      <th><Trans>{label}</Trans></th><td>{valueTrans ? <Trans>{value}</Trans> : <>{value}</>}</td>
    </tr>
  )

export default ({
    item,
    t,
    ...props
}) => {


    return (
        <>
            {item &&
                <DocumentRenderer {...props}>
                    <div className="container-fluid m-0 p-0">
                    <div>
                        <h4><Trans>Employee Details</Trans></h4>
                        <div>
                            <table className="table table-bordered">
                                <tbody>
                                    <TableValues label="Serial Number" value={item.serial_number}/>
                                    <TableValues label="Full Name" value={item.full_name} valueTrans={true}/>
                                    <TableValues label="Email" value={item.email} />
                                    <TableValues label="Phone Number" value={item.phone_number} />
                                    <TableValues label="Date of Birth" value={item.date_of_birth} />
                                    <TableValues label="Joining Date" value={item.start_date} />
                                    <TableValues label="Position" value={item.position} valueTrans={true}/>
                                    <TableValues label="Nationality" value={item.nationality} valueTrans={true}/>
                                    <TableValues label="Qualification" value={item.qualification} valueTrans={true}/>
                                    <TableValues label="ID Number" value={item.id_number} />
                                    <TableValues label="ID End Date" value={item.id_end_date} />
                                    <TableValues label="Shift Appointed" value={item.shift_adj?.name} valueTrans={true}/>
                                    <TableValues label="End Date" value={item.end_date} />
                                    <TableValues label="Holiday Balance" value={item.holiday_balance} />
                                    <TableValues label="Holiday Offset" value={item.holiday_offset} />
                                    <TableValues label="Number of Holiday Days" value={item.num_holiday_days} />
                                    <TableValues label="Insurance Start Date" value={item.start_date_insurance} />
                                    <TableValues label="Insurance Number" value={item.medical_number} />
                                    <TableValues label="Insurance Category" value={item.category} valueTrans={true}/>
                                    <TableValues label="Insurance Company" value={item.company_name} valueTrans={true}/>
                                    <TableValues label="Insurance End Date" value={item.end_date_insurance} />
                                    <TableValues label="Monthly Salary" value={item.monthly_salary} />
                                    <TableValues label="Bank Name" value={item.bank_name} valueTrans={true}/>
                                    <TableValues label="Account Number" value={item.account_number} />
                                    <TableValues label="IBAN" value={item.iban} />
                                    <TableValues label="Swift" value={item.swift} />
                                    <TableValues label="Route" value={item.route} />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </DocumentRenderer>}
        </>
    );
};
